var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "qr_bar",
    d: "M32.4533 127.33C32.4533 119.26 38.9952 112.718 47.065 112.718H207.494C215.564 112.718 222.106 119.26 222.106 127.33V127.33C222.106 135.4 215.564 141.941 207.494 141.941H47.0649C38.9952 141.941 32.4533 135.4 32.4533 127.33V127.33Z",
    fill: "#00F0FF",
    fillOpacity: 0.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 41.7475C0 18.691 18.691 0 41.7475 0H44.3837C51.9594 0 58.1007 6.14132 58.1007 13.717C58.1007 21.2927 51.9594 27.434 44.3837 27.434H41.7475C33.8424 27.434 27.434 33.8424 27.434 41.7475V42.6265C27.434 50.2022 21.2927 56.3435 13.717 56.3435C6.14132 56.3435 0 50.2022 0 42.6265V41.7475Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.812 -2.95647e-06C235.868 -1.32366e-06 254.559 18.691 254.559 41.7475L254.559 42.6265C254.559 50.2022 248.418 56.3435 240.842 56.3435C233.267 56.3435 227.125 50.2022 227.125 42.6265L227.125 41.7475C227.125 33.8424 220.717 27.434 212.812 27.434L210.176 27.434C202.6 27.434 196.459 21.2927 196.459 13.717C196.459 6.14132 202.6 -3.67966e-06 210.176 -3.14316e-06L212.812 -2.95647e-06Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.559 214.253C254.559 237.309 235.868 256 212.812 256L210.176 256C202.6 256 196.459 249.859 196.459 242.283C196.459 234.707 202.6 228.566 210.176 228.566L212.812 228.566C220.717 228.566 227.125 222.158 227.125 214.253L227.125 213.373C227.125 205.798 233.267 199.656 240.842 199.656C248.418 199.656 254.559 205.798 254.559 213.373L254.559 214.253Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7475 256C18.691 256 -1.73334e-06 237.309 -3.87152e-06 214.253L-3.95304e-06 213.373C-4.65558e-06 205.798 6.14132 199.656 13.717 199.656C21.2927 199.656 27.434 205.798 27.434 213.373L27.434 214.253C27.434 222.158 33.8424 228.566 41.7475 228.566L44.3837 228.566C51.9594 228.566 58.1007 234.707 58.1007 242.283C58.1007 249.859 51.9594 256 44.3837 256L41.7475 256Z",
    fill: "black",
    fillOpacity: 0.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.61b704a2.svg";
export { ForwardRef as ReactComponent };